import { FirebaseError } from 'firebase/app';
import { RecaptchaVerifier, Auth } from 'firebase/auth';
import { RECAPTCHA_ID } from '@constants';

export const setInvisibleRecaptchaOnWindow = async (firebaseAuth: Auth) => {
  window.recaptchaVerifier = new RecaptchaVerifier(firebaseAuth, RECAPTCHA_ID, {
    size: 'invisible',
    appVerificationDisabledForTesting: process.env.DISABLE_RECAPTCHA === 'true'
  });
  window.recaptchaWidgetId = await window.recaptchaVerifier.render();
};

export const isFirebaseError = (error: unknown): error is FirebaseError => {
  return typeof error === 'object' && error !== null && 'code' in error;
};
